import { fetcher } from '@/src/general/utilities/fetcher'

import type { TFeaturedTagApi, TFullTagApi } from './types/tagApi.types'

export const TagsApi = {
  getTags: () => fetcher.query<TFeaturedTagApi[]>('/tags', {}),
  getTag: (slug: string) => fetcher.query<TFullTagApi>(`/tags/${slug}`, {}),
}
